<footer class="footer pharmacy-footer">
    <div class="container">
        <div class="mid-footer">
            <div class="row justify-content-around">
                <div class="col-xl-3 px-2">
                    <div class="footer-links text-center">
                        <ul class="pages-links list-unstyled">
                            <li class="my-2">
                                <a href="javascript:void(0);">
                                    <img src="assets/img/footer/Logo-3iyadati.png" alt="Protected by" class="img-fluid" style="max-width: 180px;">
                                </a>
                            </li>
                            <li class="my-3">
                                <h5 >Pilotez votre cabinet simplement</h5>
                            </li>
                            <li class="social-links d-flex justify-content-center gap-3 my-3">
                                <a href="https://www.linkedin.com/company/107687478/admin/dashboard/" target="_blank" class="social-icon text-decoration-none">
                                    <i class="fab fa-linkedin fa-2x" style="color: #363F4C; transition: transform 0.3s ease;"></i>
                                </a>
                                <a href="https://www.instagram.com/3iyadaty.officiel/followers/" target="_blank" class="social-icon text-decoration-none">
                                    <i class="fab fa-instagram fa-2x" style="color: #363F4C; transition: transform 0.3s ease;"></i>
                                </a>
                                <a href="https://wa.me/212661417039" class="social-icon text-decoration-none" target="_blank">
                                    <i class="fab fa-whatsapp fa-2x" style="color: #363F4C; transition: transform 0.3s ease;"></i>
                                </a>
                                <a href="mailto:contact@3iyadaty.com" class="social-icon text-decoration-none">
                                    <i class="fas fa-envelope fa-2x" style="color: #363F4C; transition: transform 0.3s ease;"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-3 px-2 ml-3" style="margin-left: 8rem;">
                    <div class="footer-links ">
                            <h4 class=" mt-3 footer-title" >BI NEWVISION</h4>
                            <ul>
                                <li class="mt-2"><a  [routerLink]="['/footer/leaders']"  style="font-size: 16px;">Nos Dirigeants</a></li>
                                <li class=" mt-2 m-r-3"><a href="https://bi-newvision.com/" target="_blank" style="font-size: 16px;" >Site Web</a></li>
                            </ul>
                    </div>
                </div>
                <div class="col-xl-3 px-1 text-center">
                    <div class="footer-links " style="padding: 10px 0;">
                        <div class="protected-by">
                            <img src="assets/img/footer/Logo-3iyadati.png" alt="Protected by" style="max-width: 180px; display: block; margin: 0 auto 5px;">
                        </div>
                        <h5  style="margin: 15px 0">Powered By</h5>
                        <div class="app-store-links">
                            <img src="assets/img/footer/logo-binew-vision.png" alt="Protected by" style="max-width: 150px; display: block; margin: 0 auto;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom">
        <div class="copy-right text-center">
            <p>Copyright © {{ year | date:'yyyy' }} Bi-NewVision. Tous droits réservés.</p>
        </div>
    </div>

</footer>